/* Fills. Nothing here is a token: each one is a decision about the paint the
 * text sits on, which is why they live with the page and not in the global
 * stylesheet. */

/* Figma's "Section" plates (36:74 and its siblings). */
.plate {
  background: rgb(255 255 255 / 0.34);
}

/* Over the pale glass the sections sit on. */
.ink {
  color: #000;
}
